import { render, staticRenderFns } from "./ComplaintsPerCompanyAndStatus.vue?vue&type=template&id=2621cada&"
import script from "./ComplaintsPerCompanyAndStatus.vue?vue&type=script&lang=js&"
export * from "./ComplaintsPerCompanyAndStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports